import Vue from "vue";
import components from "./components/components";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";
import "@/assets/sass/main.scss";
import { i18n } from "./plugins/i18n";
import axios from "./plugins/axios";
import globalMixin from "./mixins/globalMixins";
import VueMask from "v-mask";

window.axios = axios;

Vue.config.productionTip = false;

export const eventBus = new Vue();
Vue.prototype.$eventBus = eventBus;

components.forEach(({ name, component }) => {
  Vue.component(name, component);
});

Vue.component("v-granted", require("@/directives/authorization.js"));
Vue.component("v-uppercase", require("@/directives/uppercase.js"));

Vue.mixin(globalMixin);
Vue.use(VueMask);

new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
